<script setup>
import { ref, computed, watch } from "vue";
import SortResultsBy from "@components/ResultSort.vue";
import FieldCheckbox from "@components/FieldCheckbox.vue";
import FieldSearch from "@components/FieldSearch.vue";
import languages from "@data/languages.js";
import Slider from "primevue/slider";
import { useFilterStore } from "@stores/FilterStore";
import { useBookingStore } from "@stores/BookingStore";

const props = defineProps({});
const value = ref([20, 80]);

const filterStore = useFilterStore();
const bookingStore = useBookingStore();

// Watch for changes in price range and update the store
watch(value, (newValue) => {
  filterStore.priceRange = newValue;
});
</script>

<template>
  <section class="mx-auto mt-60 max-w-[200px]">
    <h3 class="mb-40 font-medium text-grey">Filter by</h3>

    <div class="hidden lg:block items-center gap-4 mb-50 min-w-[200px]">
      <SortResultsBy />
    </div>

    <section class="mb-50" v-if="bookingStore.serviceType === 'vaccinations'">
      <h3 class="mb-20 text-grey">Vaccination price</h3>
      <div class="flex gap-4 mb-30">
        <fieldset class="frm-field">
          <label class="block mb-10 text-14 frm-label">Min</label>
          <div class="frm-input">
            <span class="text-12 text-grey/[0.6]"> £ </span>
            <input
              type="text"
              v-model.number="value[0]"
              class="!pl-5 w-full"
              aria-label="First Price Input" />
          </div>
        </fieldset>
        <fieldset>
          <label class="block mb-10 text-14 frm-label">Max</label>
          <div class="frm-input">
            <span class="text-12 text-grey/[0.6]"> £ </span>
            <input
              type="text"
              v-model.number="value[1]"
              class="!pl-5 w-full"
              aria-label="Second Price Input" />
          </div>
        </fieldset>
      </div>
      <div class="flex justify-center">
        <Slider v-model="value" :step="5" range class="w-56" />
      </div>
    </section>

    <section class="mb-50">
      <h3 class="mb-20 text-grey">Clinician Preference</h3>
      <FieldCheckbox
        v-model="filterStore.clinicianPreference"
        name="gender"
        trueValue="male"
        label="Male"
        class="mb-5" />
      <FieldCheckbox
        v-model="filterStore.clinicianPreference"
        name="gender"
        trueValue="female"
        label="Female"
        class="mb-5" />
    </section>

    <section class="mb-50">
      <FieldSearch
        name="languages"
        v-model="filterStore.languages"
        label="Languages"
        :required="false"
        :data="languages" />
    </section>

    <section class="mb-50">
      <h3 class="mb-20 text-grey">Parking</h3>
      <FieldCheckbox
        name="parking"
        v-model="filterStore.parking"
        trueValue="private_parking"
        label="Private parking"
        class="mb-5" />
      <FieldCheckbox
        name="parking"
        v-model="filterStore.parking"
        trueValue="off_street_parking"
        label="Off-street parking"
        class="mb-5" />
      <FieldCheckbox
        name="parking"
        v-model="filterStore.parking"
        trueValue="pay_display"
        label="Pay and display"
        class="mb-5" />
      <FieldCheckbox
        name="parking"
        v-model="filterStore.parking"
        trueValue="disability_access"
        label="Disability Access"
        class="mb-5" />
    </section>

    <div class="text-center">
      <button
        @click="filterStore.applyFilter"
        class="border border-blue font-medium text-blue btn">
        Apply filters
      </button>
    </div>
  </section>
</template>

<style scoped lang="scss"></style>
